import { PIXI } from "./tbPIXI";
export var mainContainer = new PIXI["Container"]();
